import React from 'react'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb } from 'admin/lib/Breadcrumbs'

import { BIReportsList } from './BIReportsList'
export function BIReports() {
  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: 'BI Reports'
            }
          ]}
        />
      }
    >
      <BIReportsList />
    </Layout>
  )
}
